import { clientSDK } from "@istari-frontend/api-client";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

import { agentQueryKeys } from "~/agent/data-source/agent-query-keys";
import { getAgentLatestDisplayName } from "~/agent/data-source/get-agent-latest-display-name";
import { DEFAULT_CACHE_TIME } from "~/constants";

const MODULE_AGENTS_PAGE_SIZE = 100;

export const agentQueryOptions = {
  byId: (id: string) =>
    queryOptions({
      queryKey: agentQueryKeys.byId(id),
      queryFn: () => clientSDK.getAgent(id),
      select: (agent) => ({ ...agent, displayName: getAgentLatestDisplayName(agent) }),
      staleTime: DEFAULT_CACHE_TIME,
    }),
  /**
   * Every agent that advertises the module at any version, one page of 100 at a time. The version is
   * deliberately not part of the query: callers mark agents on an older version instead of hiding them.
   */
  byModule: (moduleName: string | undefined) =>
    infiniteQueryOptions({
      queryKey: agentQueryKeys.byModule(moduleName ?? ""),
      queryFn: ({ pageParam }) =>
        clientSDK.listAgents(
          null,
          null,
          null,
          moduleName,
          null,
          null,
          null,
          undefined,
          null,
          undefined,
          pageParam,
          MODULE_AGENTS_PAGE_SIZE,
        ),
      initialPageParam: 1,
      getNextPageParam: (lastPage, _allPages, lastPageParam: number) =>
        lastPage.items.length === 0 || lastPage.page >= lastPage.pages ? undefined : lastPageParam + 1,
      staleTime: DEFAULT_CACHE_TIME,
    }),
};
